module.exports = __webpack_public_path__ + "media/stars/blue-shooting-star-14573f1e.svg";